module.exports = __webpack_public_path__ + "img/ua-education-logo.09ec0579.jpg";